<script setup lang="ts">

import { getTokenAssetUrl, tokenSlugMap } from '@/helpers/game'
import TheBottomSheet from '@/components/TheBottomSheet.vue'
import type { Token } from '@/enums/token'
import { T } from '@tolgee/vue'
import BaseButton from '@/components/base/BaseButton.vue'
import CoinIcon from '@/components/icons/CoinIcon.vue'
import { useHapticFeedback } from '@/composables/game/haptic-feedback'

defineProps<{
  show: boolean
  token: Token
}>()
defineEmits(['hide'])

const { addHapticFeedback } = useHapticFeedback()

</script>

<template>
  <TheBottomSheet
    :show="show"
    @hide="$emit('hide')"
  >
    <div class="w-full flex flex-col items-center">
      <div
        class="w-[120px] h-[120px] min-w-[120px] flex items-center justify-center"
      >
        <img
          :src="getTokenAssetUrl(tokenSlugMap[token])"
          class="w-auto h-full object-cover"
        >
      </div>
      <div class="mt-6 text-white text-center text-[24px] leading-8 font-bold -tracking-[0.48px] uppercase">
        <T
          key-name="tokens.your_chosen_token_is"
          default-value="Your chosen token is"
        />
      </div>
      <div
        class="mt-6 text-green-primary text-[24px] leading-10 font-bold -tracking-[0.5px]"
      >
        {{ token }}
      </div>
      <BaseButton
        class="w-full mt-8"
        @click="addHapticFeedback(); $emit('hide');"
      >
        <template #leftIcon>
          <CoinIcon class="w-auto h-full" />
        </template>
        <T
          key-name="tokens.good_luck"
          default-value="Good luck"
        />
      </BaseButton>
    </div>
  </TheBottomSheet>
</template>

<style scoped>
.token-name-shadow {
  text-shadow: 0px 0px 9.1px #DB53FA;
}
</style>